import { gql } from '@apollo/client';

const PREVIEW_TOKEN_MUTATION = gql`
  mutation createPreviewToken($itemId: String!, $itemEntity: String!) {
    createPreviewToken(input: { itemId: $itemId, itemEntity: $itemEntity }) {
      result {
        url
      }
    }
  }
`;

export { PREVIEW_TOKEN_MUTATION };
